import React from "react";
import { TitleTypography } from "./style";

export default function Text({ children }) {
  return <TitleTypography>{children}</TitleTypography>;
}
